export const VALIDATION_PATTERNS = {
  PHONE_NUMBER: /^\+[1-9]{1}[0-9]{7,14}$/im,
  EMAIL: /^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$/im,
};
